import { IApiResponse } from "../../Types/ApiResponse.model";
import { api } from "../ApiState";

export const InquiriesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    ibanInquiry: builder.mutation<IApiResponse<any>, { iban: string }>({
      query: (body) => ({
        url: "services/inquiry-iban-number",
        method: "POST",
        body,
      }),
    }),
    nationalIdentity: builder.mutation<
      IApiResponse<any>,
      { national_code: string; birth_date: string }
    >({
      query: (body) => ({
        url: "services/verify-national-identity",
        method: "POST",
        body,
      }),
    }),
    postalCodeInquiry: builder.mutation<
      IApiResponse<any>,
      { postalCode: string }
    >({
      query: (body) => ({
        url: "services/inquiry-postal-code",
        method: "POST",
        body,
      }),
    }),
    cardToIban: builder.mutation<IApiResponse<any>, { card: string }>({
      query: (body) => ({
        url: "services/convert-card-to-iban",
        method: "POST",
        body,
      }),
    }),
    depositToIban: builder.mutation<
      IApiResponse<any>,
      { deposit: string; bankCode: string; bank: string }
    >({
      query: (body) => ({
        url: "services/deposit-to-iban",
        method: "POST",
        body,
      }),
    }),
    matchNationalToIban: builder.mutation<
      IApiResponse<any>,
      { nationalCode: string; birthDate: string; iban: string }
    >({
      query: (body) => ({
        url: "services/check-iban-national-code",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useIbanInquiryMutation,
  useNationalIdentityMutation,
  usePostalCodeInquiryMutation,
  useCardToIbanMutation,
  useDepositToIbanMutation,
  useMatchNationalToIbanMutation,
} = InquiriesApi;

export default InquiriesApi;
